import { useNavigate } from "react-router";
import React, { useEffect } from "react";

import SessionStore from "../../model/SessionStore";

function SiteRedirect() {
  const navigate = useNavigate();

  const siteId = SessionStore.getSiteId();
  console.log('siteId',siteId);
  useEffect(() => {
    if (siteId && siteId !== "") {
      navigate(`/site/${siteId}/dash`);
    } else {
    
      SessionStore.getClient().getAllSites(SessionStore.getBearer()).then((resp) => {
        console.log('resp:',resp);
        
        if (resp.data.length !== 0) {
          navigate(`/site/${resp.data[0].id}/dash`);
        }else{
          navigate(`/sites`);
        }
      });
    }
  },[siteId]);

  return null;
}

export default SiteRedirect;
